const navLinkStyledConfirmTenant = {
  text: 'Volte para página inicial para entrar'
};

export default navLinkStyledConfirmTenant;
